var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.showClose ? _c("el-button", {
    staticClass: "close",
    attrs: {
      type: "danger",
      size: "mini"
    },
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("关闭 ")]) : _vm._e(), _c("el-dialog", {
    attrs: {
      title: "关闭咨询",
      visible: _vm.visible,
      width: "320px",
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c("div", {
    staticClass: "wlc-f-c dialog-title",
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_c("i", {
    staticClass: "el-icon-info tip-icon"
  }), _vm._v(" 关闭咨询 ")]), _c("span", [_vm._v("咨询关闭后无法重新开启，确定要关闭吗？")]), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("取消")]), _c("el-button", {
    attrs: {
      type: "primary",
      size: "small",
      loading: _vm.loading
    },
    on: {
      click: _vm.confirmClose
    }
  }, [_vm._v("确定")])], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };